export const selectCurrentStage = (state) =>
  (state.contest.stages || []).find((stage) => stage.isCurrent) || null;
